import { worker } from '../../../app/web-workers/aws-web-worker';
import { API_NAMES } from '../../../helpers/constants';

export const requestReportTPMSSnapshot = () => {
  return worker.Api({ method: 'get', api: API_NAMES.ODR_LIVE_MAP, endpoint: 'analytics/tpmsReport' });
};
